import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {useSelector} from '../../../state/hooks';
import {getSharePanelLink} from '../../Panel/FullScreenPanel/fullScreenUtils';
import {usePanelContext} from '../../Panel/PanelContextProvider';
import {useSharedPanelStateMaybe} from '../../Panel/SharedPanelStateContext';
import {appendZoomParamsToURL} from '../../Panel/zoomURLUtils';

export function useFullscreenPanelLink(): string {
  const {panel, panelBankSectionConfigRef} = usePanelContext();
  const location = useLocation();
  const {userZoomState} = useSharedPanelStateMaybe() ?? {};
  const panelBankSectionName = useSelector(state => {
    if (panelBankSectionConfigRef == null) {
      return '';
    }

    return (
      state.views.parts[panelBankSectionConfigRef.type][
        panelBankSectionConfigRef.id
      ]?.name ?? ''
    );
  });

  return useMemo(() => {
    let link = getSharePanelLink(panel, panelBankSectionName, location);
    if (userZoomState) {
      link = appendZoomParamsToURL(link, userZoomState);
    }
    return link;
  }, [panel, panelBankSectionName, location, userZoomState]);
}
